import * as ActionTypes from '../actions/auth'
import auth from '../common/auth'

export default (
	state = {
		isAuthenticated: auth.isLoggedIn()
	},
	action
) => {
	switch (action.type) {
		case ActionTypes.LOGIN_SUCCESS:
			return {
				isAuthenticated: true
			}
		case ActionTypes.LOGOUT_SUCCESS:
			return {
				isAuthenticated: false
			}
		case ActionTypes.LOGIN_ERROR:
			return {
				isAuthenticated: false
			}
		default:
			return state
	}
}



// WEBPACK FOOTER //
// ./src/reducers/auth.js